import React, { useEffect } from "react";
import firebaseManager from "../../model/Firebase/FirebaseManager";


const AllCards = () => {
  const getDent = () => {
    firebaseManager.showAllDentsAdmin();
  };

  useEffect(() => {
    getDent();
  }, []);

  function handleClick() {
    window.location = "/dent_information";
  }

  return (
    <React.Fragment>
      
      <div onClick={handleClick} id="allDent" className="mt-5 mb-5 pb-5"></div>
    </React.Fragment>
  );
};

export default AllCards;